export const environment = {
  production: true,
  BASE_URL: 'https://rh.demax.com.br',
  API: '/api',
  BASE_SERVER: 'https://rh.demax.com.br'
};
